import { useSubscribeButtonItemProps } from './SubscribeButton/SubscribeButton';
import { useRssButtonItemProps } from './RssButton/RssButton';
import {
  ActionButton,
  CommandBar,
  FontSizes,
  ScreenWidthMinLarge,
} from '@fluentui/react';
import { useApiButtonItemProps } from './useApiButtonItemProps';
import { usePowerShellButtonItemProps } from './PowerShellButton/PowerShellButton';
import { useCsafButtonItemProps } from './CsafButton/CsafButton';
import compact from 'lodash/compact';

/**
 * This is a cluster of buttons that are used to subscribe to the site.
 */
export const SubscribeButtonCluster = () => {
  const subscribeButtonProps = useSubscribeButtonItemProps();
  const rssButton = useRssButtonItemProps();
  const apiButton = useApiButtonItemProps();
  const powerShellButton = usePowerShellButtonItemProps();
  const csafButton = useCsafButtonItemProps();

  const isSmallScreen = window.innerWidth < ScreenWidthMinLarge;

  const buttonItems = compact([
    {
      key: 'subscribe',
      ...subscribeButtonProps,
    },
    {
      key: 'rss',
      ...rssButton,
    },
    {
      ...powerShellButton,
    },
    {
      ...apiButton,
    },
    {
      ...csafButton,
    },
  ]);

  if (isSmallScreen) {
    return (
      <ActionButton
        styles={{ menuIcon: { fontSize: FontSizes.small } }}
        title='Connect to MSRC Security Updates'
        menuProps={{
          title: 'Connect',
          items: buttonItems,
        }}
      >
        Connect
      </ActionButton>
    );
  }

  return (
    <div
      style={{
        position: 'relative',
        flexBasis: '35%',
        height: '100%',
      }}
    >
      <div
        style={{
          position: 'absolute',
          right: '0',
          top: '0',
          bottom: '0',
        }}
      >
        <CommandBar
          styles={{
            root: {
              height: '100%',
              background: 'transparent',
              fontSize: FontSizes.small,
              padding: '0',
            },
          }}
          items={buttonItems}
        />
      </div>
    </div>
  );
};
